import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CarouselIndicatior = ({active, carouselHtmlId, className, index}) => {
    
    const carouselClassValue = classNames(
        {"active": active},
        className
    );

    return(
        <li
            data-target={`#${carouselHtmlId}`}
            data-slide-to={index}
            className={carouselClassValue} />
    );
};

CarouselIndicatior.propTypes = {
    //Should component have active class
    active: PropTypes.bool,
    //Carousel html id
    carouselHtmlId: PropTypes.string,
    //Class to apply
    className: PropTypes.string,
    //Component index as string.
    index: PropTypes.string
};

export default CarouselIndicatior;


// WEBPACK FOOTER //
// ./src/components/Carousel/CarouselIndicatior.js